/**
 * 목록 엑셀 다운로드용 페이지 순회.
 * 화면 페이지 크기와 무관하게 size=2000으로 끝까지 모은다.
 */
import type { PageResponse } from '@/entities/user/api/user.api';

export const LIST_EXPORT_PAGE_SIZE = 2000;
export const LIST_EXPORT_MAX_PAGES = 5000;

export const fetchAllPagedItems = async <T>(
  fetchPage: (page: number, size: number) => Promise<PageResponse<T>>,
  pageSize = LIST_EXPORT_PAGE_SIZE,
  maxPages = LIST_EXPORT_MAX_PAGES,
): Promise<T[]> => {
  const accumulated: T[] = [];
  let totalTarget: number | null = null;

  for (let page = 0; page < maxPages; page += 1) {
    const data = await fetchPage(page, pageSize);
    const chunk = Array.isArray(data?.content) ? data.content : [];

    if (page === 0 && data?.totalCount != null) {
      const n = Number(data.totalCount);
      if (Number.isFinite(n) && n >= 0) {
        totalTarget = n;
      }
    }

    accumulated.push(...chunk);

    if (chunk.length === 0) break;
    if (data?.isLast) break;
    if (totalTarget != null && accumulated.length >= totalTarget) break;
    if (chunk.length < pageSize) break;
  }

  return accumulated;
};
